import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-primary text-white">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-xl font-bold text-white mb-4">MoreLove</h3>
            <p className="text-sm">
              Organisation à but non lucratif chrétienne de droit américain, créée dans l'État du Maryland, 
              reconnue comme une organisation à but non lucratif sous le code 501(C)(3).
            </p>
            <blockquote className="text-white italic mt-4 border-white">
              "Mais par dessus toute ces choses, revêtez-vous de la charité qui est le lien de la perfection" 
              <span className="block mt-1">Colossiens 3:14</span>
            </blockquote>
          </div>
          
          <div>
            <h3 className="text-xl font-bold text-white mb-4">Liens rapides</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="hover:text-tertiary transition-colors">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-tertiary transition-colors">
                  Qui sommes-nous
                </Link>
              </li>
              <li>
                <Link to="/mission" className="hover:text-tertiary transition-colors">
                  Notre mission
                </Link>
              </li>
              <li>
                <Link to="/domains" className="hover:text-tertiary transition-colors">
                  Domaines d'intervention
                </Link>
              </li>
              <li>
                <Link to="/membership" className="hover:text-tertiary transition-colors">
                  Devenir membre
                </Link>
              </li>
              <li>
                <Link to="/donate" className="hover:text-tertiary transition-colors">
                  Faire un don
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-tertiary transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-xl font-bold text-white mb-4">Contact</h3>
            <address className="not-italic">
              <div className="mb-2">
                <strong>Siège social:</strong><br />
                États-Unis / État du Maryland<br />
                Tel: +1(347) 591-8720<br />
                Tel: +1(347) 469 2799
              </div>
              <div className="mb-2">
                <strong>Représentation Côte d'Ivoire:</strong><br />
                Abidjan—Cocody—Angré<br />
                Tel: 00225 07 59 98 34 89
              </div>
              <div className="mb-2">
                <strong>Email:</strong><br />
                <a href="mailto:morelovedm@gmail.com" className="hover:text-tertiary transition-colors">
                  morelovedm@gmail.com
                </a>
              </div>
            </address>
          </div>
        </div>
        
        <div className="border-t border-white/20 mt-8 pt-6 text-center">
          <p className="text-sm">
            &copy; {new Date().getFullYear()} MoreLove Inc. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
